import redirectPermanently from '@/components/Redirect/redirectPermanently';

const Redirect = () =>
  redirectPermanently(
    '/entrenamientos/official-scrum-developer-certification-training'
  );

export default Redirect;
